import React from 'react';
import { Form, Input, InputNumber } from 'antd';
import PropTypes from 'prop-types';
import InputRequired from './InputRequired';

const FormItem = Form.Item;

// Input type maybe text or password
export default function TextInput(props) {
  const {
    getFieldDecorator,
    required,
    fieldName,
    limitValue,
    label,
    type,
    value,
    placeholder,
    disable
  } = props;
  const labelConvert = required ? <InputRequired name={label} /> : label;
  const limitValueData = limitValue || {};
  if (type === 'vnd') {
    return (
      <FormItem label={labelConvert}>
        {getFieldDecorator(fieldName, {
          rules: [
            { required, message: `Cần điền ${label}`, ...limitValueData }
          ],
          initialValue: value
        })(
          <InputNumber
            formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
            parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
            style={{ width: '100%' }}
          />
        )}
      </FormItem>
    );
  } if (type === 'numDouble') {
    return (
      <FormItem label={labelConvert}>
        {getFieldDecorator(fieldName, {
          rules: [
            { required, message: `Cần điền ${label}`, ...limitValueData }
          ],
          initialValue: value
        })(
          <InputNumber
            formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
            parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
            step={0.1}
            style={{ width: '100%' }}
          />
        )}
      </FormItem>
    );
  } if (type === 'phone') {
    return (
      <FormItem label={labelConvert}>
        {getFieldDecorator(fieldName, {
          rules: [
            { required, message: `Cần điền ${label}`, ...limitValueData }
          ],
          initialValue: value
        })(
          <InputNumber
            parser={(value) => `0${value}`}
            style={{ width: '100%' }}
          />
        )}
      </FormItem>
    );
  }
  return (
    <FormItem label={labelConvert}>
      {getFieldDecorator(fieldName, {
        rules: [
          { required, message: `Cần điền ${label}`, ...limitValueData }
        ],
        initialValue: value
      })(
        <Input disabled={disable} placeholder={placeholder} type={type} />
      )}
    </FormItem>
  );
}

TextInput.propTypes = {
  getFieldDecorator: PropTypes.objectOf(PropTypes.any).isRequired,
  required: PropTypes.bool,
  fieldName: PropTypes.string.isRequired,
  limitValue: PropTypes.string,
  label: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  disable: PropTypes.bool
};

TextInput.defaultProps = {
  required: false,
  limitValue: '',
  placeholder: '',
  disable: false
};
